import { useRef, useState } from "react";
import { Modal, Button } from "@etframework/ui.components";
import { useTranslation } from "react-i18next";
import useModalEvent from "../../hooks/useModalEvent";
import ReactDOM from "react-dom";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { useUpdateGroupVisibility } from "../../data/mutations/customFieldGroupMutation";
import { useTaskType } from "../../data/queries/taskTypeQueries";
import { useQueryClient } from "@tanstack/react-query";

export const InactivateFieldGroupModal = () => {
  const { t } = useTranslation(["CustomFieldGroup"], {
    useSuspense: false,
  });

  const { taskTypeId } = useParams();
  const { data: taskType } = useTaskType(taskTypeId);
  const queryClient = useQueryClient();

  const [groupId, setGroupId] = useState(null);

  const { mutate: updateGroupVisibility, isPending } =
    useUpdateGroupVisibility();

  const onVisibilityChange = () => {
    updateGroupVisibility(
      {
        visibility: {
          Id: groupId,
          Visible: false,
        },
      },
      {
        onSuccess: () => {
          queryClient.invalidateQueries(["get-custom-field-group", groupId]);
          modalRef.current?.close();
          toast.success(t("SuccessUpdate"), { position: "bottom-left" });
        },
        onError: () => {
          toast.error(t("ErrorMsg"), { position: "bottom-left" });
        },
      }
    );
  };

  //Modal
  const modalRef = useRef();
  const { ModalEvents, useRegisterEvent } = useModalEvent();
  const [showModal, setShowModal] = useState(false);

  const onModelBeforeClose = () => {};

  const onModalClose = () => {
    setShowModal(false);
  };

  const closeModal = () => {
    setShowModal(false);
    modalRef?.current?.close();
  };

  const openModal = () => {
    setShowModal(true);
    modalRef?.current?.open();
  };

  const toggleModal = (event) => {
    setGroupId(event?.detail?.groupId);
    if (showModal) {
      closeModal();
      return;
    } else {
      openModal();
    }
  };

  const ModalContent = () => {
    return (
      <div className="et-inactivate-field-group-modal">
        <div className="fw-700 fs-16 d-block pb-3">
          {t("InactivateFieldGroupModal.InactivateFieldGroupHeader")}
        </div>

        <div className="pb-3">
          {t("InactivateFieldGroupModal.InactivateFieldGroupMessage", {
            taskType: taskType?.Title,
          })}
        </div>

        <div className="d-flex justify-content-end gap-3 pt-3">
          <Button
            text={t("Cancel")}
            className="btn-tertiary w-auto"
            onClick={toggleModal}
          />
          <Button
            id={ModalEvents.InactivateFieldGroupModal.Id + "_inactivate-button"}
            text={t("InactivateFieldGroupModal.InactivateFields")}
            className="btn btn-primary w-auto"
            onClick={onVisibilityChange}
            loading={isPending}
          />
        </div>
      </div>
    );
  };

  useRegisterEvent(ModalEvents.InactivateFieldGroupModal, toggleModal);

  return ReactDOM.createPortal(
    <>
      <Modal
        id={ModalEvents.InactivateFieldGroupModal.Id}
        ref={modalRef}
        isModal
        showCloseIcon={true}
        visible={showModal}
        content={<ModalContent />}
        close={onModalClose}
        beforeClose={onModelBeforeClose}
        minHeight="276px"
        width="487px"
      ></Modal>
    </>,
    document.body
  );
};
